import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { ShieldStar } from "@phosphor-icons/react";

export default function ControlLogin() {
  const { login, logout } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      if (u?.is_super_admin) { nav("/control", { replace: true }); }
      else { await logout(); toast.error("This portal is for super-admins only."); }
    } catch (err) { toast.error("Invalid credentials"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0B0D10] text-stone-100 flex items-center justify-center px-4"
      style={{ backgroundImage: "radial-gradient(1200px 500px at 50% -10%, rgba(194,65,12,0.18), transparent)" }}>
      <div className="w-full max-w-sm" data-testid="control-login">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-11 h-11 rounded-xl bg-[#C2410C] grid place-items-center shadow-lg">
            <ShieldStar size={22} weight="fill" className="text-white" />
          </span>
          <div>
            <div className="font-head font-semibold text-lg leading-tight">Inspiro Control</div>
            <div className="text-xs text-stone-400 tracking-wide uppercase">Super-Admin Portal</div>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4 bg-[#14171C] border border-white/10 rounded-2xl p-6">
          <div>
            <label className="text-xs uppercase tracking-wider text-stone-400">Email</label>
            <Input data-testid="control-login-email" type="email" value={email} required
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 rounded-xl bg-[#0F1216] border-white/10 text-stone-100 placeholder:text-stone-500" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-stone-400">Password</label>
            <Input data-testid="control-login-password" type="password" value={password} required
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 rounded-xl bg-[#0F1216] border-white/10 text-stone-100" />
          </div>
          <Button data-testid="control-login-submit" type="submit" disabled={busy}
            className="w-full rounded-xl bg-[#C2410C] hover:bg-[#9A3412] h-11">
            {busy ? "Signing in…" : "Enter Control Portal"}
          </Button>
        </form>
        <p className="mt-4 text-center text-xs text-stone-500">Restricted access · all actions are audit-logged</p>
      </div>
    </div>
  );
}
